module.exports = __webpack_public_path__ + "images/94bb3b690977bd927a733761f882b1def6856baf2310b0622ecbc7fee72f3425.svg";